module.exports = __webpack_public_path__ + "img/en_co-fundedbytheeu_rgb_pos.9578c578.png";